import React from 'react';
import { CSSProperties } from 'react';
type OrnamentProps = {
  className?: string;
  color?: string;
  style?: CSSProperties;
};
export function HerbSprig({
  className = '',
  color = '#647D56',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-102" data-mp="3g79hev5bft5r">
      <path d="M12 22V7" data-id="element-103" data-mp="cnn6u93drt6n" />
      <path d="M12 16c-1.7-3.7-4.5-4.1-6.4-3.3.4 2.9 2.7 4.5 6.4 3.3Z" data-id="element-104" data-mp="7qes6ihfy7a5" />
      <path d="M12 12c1.6-3.7 4.3-4.2 6.3-3.3-.3 2.8-2.6 4.5-6.3 3.3Z" data-id="element-105" data-mp="3pb9lo80dx58" />
      <path d="M12 8C10.8 4.6 8.5 3.4 6.6 3.5c0 2.9 1.7 4.7 5.4 4.5Z" data-id="element-106" data-mp="3ni3ca1b5exr" />
      <path d="M12 7c1-3.3 3.3-4.4 5.3-4.1.2 2.9-1.4 4.7-5.3 4.1Z" data-id="element-107" data-mp="3uukvp4svtr9k" />
    </svg>;
}
export function LeafCluster({
  className = '',
  color = '#2E5946',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-108" data-mp="2jffnjl9zf0ik">
      <path d="M4 21c3.3-7 7.4-10.9 15-17" data-id="element-109" data-mp="2iv2y44ka9mqd" />
      <path d="M8.4 15.9c-3-3.1-3-6.9-2.1-9.5 3.2.3 6 2.7 5.6 6.6" data-id="element-110" data-mp="24wmkrurx0xz9" />
      <path d="M12.5 11.5c.2-3.8 3.1-6.2 6.1-7.2.8 3.1-.2 6.5-3.8 8.1" data-id="element-111" data-mp="24yfph4iyx84m" />
      <path d="M6.1 19.4c3.2-.3 5.9 1.4 7.3 3.2-3.1 1-6.1.1-7.3-3.2Z" data-id="element-112" data-mp="29tms090i46ry" />
    </svg>;
}
export function MortarPestle({
  className = '',
  color = '#B66735',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-113" data-mp="1zykzd370omkm">
      <path d="m14.7 5.1 4.2 4.2" data-id="element-114" data-mp="1c7fjwp4znwau" />
      <path d="m12.2 8 5.7-5.7 1.8 1.8L14 9.8" data-id="element-115" data-mp="1c8gxp1de2ww9" />
      <path d="M4 11h13.5c0 5.8-2.6 9-6.8 9S4 16.8 4 11Z" data-id="element-116" data-mp="1c9s0axv3lyls" />
      <path d="M2.5 11h16" data-id="element-117" data-mp="1h57czmhddogm" />
    </svg>;
}
export function Mandala({
  className = '',
  color = '#B88A35',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="none" stroke={color} strokeWidth="1" aria-hidden="true" data-id="element-118" data-mp="3e4zjov9qmx7s">
      <circle cx="50" cy="50" r="44" data-id="element-119" data-mp="3a19xudkg6tqg" />
      <circle cx="50" cy="50" r="30" data-id="element-120" data-mp="354tb9nswcnfh" />
      <circle cx="50" cy="50" r="12" data-id="element-121" data-mp="355un3uhqldy9" />
      <path d="M50 6v88M6 50h88M18.9 18.9l62.2 62.2M81.1 18.9 18.9 81.1" data-id="element-122" data-mp="5p636gfeplqq" />
      <path d="M50 20c10 9 10 21 0 30-10-9-10-21 0-30ZM50 50c10 9 10 21 0 30-10-9-10-21 0-30ZM20 50c9-10 21-10 30 0-9 10-21 10-30 0ZM50 50c9-10 21-10 30 0-9 10-21 10-30 0Z" data-id="element-123" data-mp="5od3fzev7wi3" />
    </svg>;
}
export const FeatherQuill = HerbSprig;
export const Flame = MortarPestle;
export const MoonPhase = LeafCluster;
export const LotusBud = Mandala;